/**
 *
 * SnackBar
 *
 */
import { Snackbar, SnackbarContent } from '@mui/material';
import clsx from 'clsx';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeThemeStyle } from 'styles/makeThemeStyle';
import {
  WarningIcon,
  ErrorIcon,
  SuccessIcon,
  InfoIcon,
} from '../Icons/ToasterIcons';
import { useToasterBarSlice } from './slice';
import { selectToasterBar } from './slice/selectors';

interface Props {}

const useStyles = makeThemeStyle(theme => ({
  warning: {
    color: theme.palette.warning.main,
  },
  error: {
    color: theme.palette.error.main,
  },
  info: {
    color: theme.palette.info.main,
  },
  success: {
    color: theme.palette.asseticPrimary.main,
  },
  default: {
    color: theme.palette.text.primary,
  },
  snackbarContent: {
    background: theme.palette.background.default,
    borderRadius: theme.spacing(0.5),
    borderBottom: '2.5px solid',
    padding: theme.spacing(0, 2),
  },
}));

const variantIcons = {
  warning: WarningIcon,
  error: ErrorIcon,
  success: SuccessIcon,
  info: InfoIcon,
};

export function ToasterBar(props: Props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    actions: { hideToast, shiftToast },
  } = useToasterBarSlice();

  const {
    open,
    toaster: { message, type } = {
      message: '',
      type: '',
    },
  } = useSelector(selectToasterBar);

  /* istanbul ignore next */
  const handleClose = (event: React.SyntheticEvent | Event, reason: string) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(hideToast());
  };

  /* istanbul ignore next */
  const handleExit = () => {
    dispatch(shiftToast());
  };

  const Icon = variantIcons[type ?? 'info'] ?? variantIcons.info;
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      autoHideDuration={5000}
      onClose={handleClose}
      TransitionProps={{
        onExited: handleExit,
      }}
    >
      <SnackbarContent
        className={clsx(
          { [classes[type] ?? classes.default]: true },
          classes.snackbarContent,
        )}
        message={message}
        action={[<Icon key={'SnackbarContent_Icon'} />]}
      />
    </Snackbar>
  );
}
